import Vue from 'vue'
import ElementUI from 'element-ui'
import './assets/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'lib-flexible/flexible'
import './app/assets/iconfont/iconfont.css'
import './app/assets/globalStyles/global.scss'
import GenH5 from './app/GenH5/index.vue'
import VideoPlayer from 'vue-video-player'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  render: h => h(GenH5)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js